import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Row, Stack } from 'react-bootstrap';
// import '../../Scss/Form.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { useFieldArray, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import RHFTextField from '../../FunctionalComponent/FormElement/RHTextField';
import FormProvider from '../../FunctionalComponent/FormElement/FormProvider';
import RHSelectField from '../../FunctionalComponent/FormElement/RHSelectField';
import { useCreate_Update_sizeMutation, useGetsizeMutation } from '../../Redux/SizeSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useCreateSpecificationTypeMutation } from '../../Redux/specification/specificationApi';
import { toast } from 'react-toastify';






function CreateSpecificationType(props) {
    
     const [createSpectificationTypeFn,{error:spectificationTypeErr, isLoading:spectificationTypeLoading, isSuccess:spectificationTypSuccess, data:spectificationTypData}] = useCreateSpecificationTypeMutation();

    const { setOpen, SizeData, open } = props;
    const [CreateUpdateSizeFunc] = useCreate_Update_sizeMutation();
    
    
    const [GetsizeFunc] = useGetsizeMutation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const buttons = [
        <Button key="one">One</Button>,
        <Button key="two">Two</Button>,
        <Button key="three">Three</Button>,
    ];


    let title = {
        header: `Specification ${SizeData?.id ? 'Update' : 'Add'}`,
        submit: `${SizeData?.id ? 'Update' : 'Save'}`
    };

    let initialState = {
        specificationTypes:[ {name: '',
        slug: ''}]
       
    };

    const schema = Yup.object().shape({
        specificationTypes: Yup.array().of(
          Yup.object().shape({
            name: Yup.string().required('Name is required'),
            slug: Yup.string().required('Slug is required'),
          })
        ),
      });
    

    const methods = useForm({
        // resolver: yupResolver(schema),
        defaultValues: initialState,
        mode: 'all',
    });
    const {
        handleSubmit,
        reset,
        setError,
        setValue,
        getValues,
        control
    } = methods;

    const onSubmit = (data) => {
        
        createSpectificationTypeFn(data);

        
    }
    const handleDelete = () => {
        console.info('You clicked the delete icon.');
    };
    useEffect(() => {
        if (SizeData?.id) {
            GetsizeFunc(SizeData?.id).then(res => {
                const getsizedata = res?.data?.response
                Object.keys(initialState).forEach((fieldname) => {
                    setValue(fieldname, getsizedata[`${fieldname}`]);
                })

            })
        }
    }, [SizeData?.id])

    const handleClose = () => {
        setOpen(false);
    };

   

    const { fields, append, remove } = useFieldArray({
        control,
        name: "specificationTypes"
    });
    
    useEffect(() => {

        // rror:spectificationTypeErr, isLoading:spectificationTypeLoading, isSuccess:spectificationTypSuccess, data:spectificationTypData}
        if (spectificationTypSuccess) {
            const message = spectificationTypData?.message || "Product created successfully";
            toast.success(message);
            // dispatch(setProductInfo({ ...getValues(), productId: data?.response }))
            setOpen(false);




        }
        if (spectificationTypeErr) {
            if ('data' in spectificationTypeErr) {
                const errorData = spectificationTypeErr;
                const errorMessage=errorData.data.message||'Something went wrong'
const errSlug=spectificationTypeErr?.data?.additional?.slug
           
                    setError(`specificationTypes.${getValues('specificationTypes').findIndex(field => field.slug==errSlug)}.name`, {
                      type: 'manual',
                      message: `${errSlug} Already exists`,
                    });
                toast.error(errorData.data.message||'Something went wrong');

            }
        }
    }, [spectificationTypData, spectificationTypSuccess, spectificationTypeErr]);
    return (
        <>
            <Modal id="showModal" className="fade zoomIn" size="lg" title={title}
                show={open} onHide={() => { setOpen(!open) }} centered>
                <Modal.Header className="px-4 pt-4" closeButton>
                    <h5 className="modal-title fs-18" id="exampleModalLabel">Add Specification Type</h5>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <FormProvider className="tablelist-form" methods={methods} onSubmit={handleSubmit(onSubmit)} >
                        <Row>
                            <div id="alert-error-msg" className="d-none alert alert-danger py-2"></div>
                            <input type="hidden" id="id-field" />
                            <p className='mb-0'>Add Specification Type</p>
                            {fields.map((field, index) =>
                            {
                                const fieldName =`specificationTypes.${index}.name`;
                                const fieldSlugName =`specificationTypes.${index}.slug`;

                               return  <Col lg={12} key={field.slug}>
                                    <div className="mb-3 d-flex justify-content-between gap-2">
                                        <div className="w-100">
                                            <RHFTextField 
                                            label='Name'
                                                  
                                            onChange={
                                                e=>{
                                                    setValue(fieldName, e.target.value);
                                                    setValue(fieldSlugName, e.target.value?.split(' ').join('-'));

                                                }
                                            }
                                            
                                            name={fieldName} />
                                        </div>
                                        <div className="align-items-end d-flex gap-1 hstack  align-self-center">
                                            <Button variant='primary' id="add-btn" type="button" onClick={() => append()} className='py-1 px-2'><i className="ri-add-box-line fs-22"></i></Button>
                                            <Button variant='primary' id="add-btn" type="button" disabled={fields?.length === 1} onClick={() => remove(index)} className='py-1 px-2'><i className="ri-delete-bin-5-fill fs-22"></i></Button>
                                        </div>
                                    </div>
                                </Col>}
                            )}
                            <Col lg={12} className="modal-footer">
                                <div className="hstack gap-2 justify-content-end">
                                    <Button className="btn-ghost-danger" onClick={() => { setOpen(false) }}><i className="ri-close-line align-bottom me-1"></i> Close</Button>
                                    <Button variant='primary' id="add-btn" disabled={spectificationTypeLoading} type="submit">Save</Button>
                                </div>
                            </Col>
                        </Row>
                    </FormProvider>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default CreateSpecificationType;
